module.exports = __webpack_public_path__ + "static/media/StartServiceIcon.a3b40567.png";